import { render } from "./MarketingMehodTips.vue?vue&type=template&id=42b0c7e0"
import script from "./MarketingMehodTips.vue?vue&type=script&lang=js"
export * from "./MarketingMehodTips.vue?vue&type=script&lang=js"

import "./MarketingMehodTips.vue?vue&type=style&index=0&id=42b0c7e0&lang=scss"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__